import React from 'react';
import { useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import {
	BasicButton,
	LoadingSection,
	TextInput
} from '../../UI';
import LoggedLayoutRoot from './LoggedLayoutRoot';
import { secondary } from '../../styles/colors';


const CreatePortalForm = ({ refetch, match, translate }) => {
	const [name, setName] = React.useState('');
	const [council, setCouncil] = React.useState({});
	const [error, setError] = React.useState(null);
	const client = useApolloClient();
	const [isLoading, setIsLoading] = React.useState(false);

	const getCouncilById = React.useCallback(async () => {
		setIsLoading(true);
		const response = await client.query({
			query: gql`
			query council($id: Int!){
				council(id: $id) {
					id
					dateStart
				}
			}
			`,
			variables: {
				id: parseInt(match.params.id, 10)
			}
		});
		if (response.data) {
			setIsLoading(false);
			setCouncil(response.data.council);
		}
	}, [match.params.id]);

	React.useEffect(() => {
		getCouncilById();
	}, [match.params.id]);

	const createPortal = async () => {
		if (!name || !name.trim()) {
			setError(translate.enter_valid_name);
			return;
		}
		const checkName = await client.query({
			query: gql`
                query CouncilPortal($name: String!){
                    councilPortal(name: $name){
                        name
                    }
                }
            `,
			variables: {
				name
			}
		});
		if (checkName?.data?.councilPortal) {
			setError('Este nombre ya está en uso'); // TRADUCCIÓN
			return;
		}
		const response = await client.mutate({
			mutation: gql`
		        mutation CreatePortal($councilId: Int!, $options: CouncilPortalInput, $dateStart: String!){
		            createPortal(councilId: $councilId, options: $options, dateStart: $dateStart){
		                id
		            }
		        }
		 `,
			variables: {
				councilId: council.id,
				options: {
					name
				},
				dateStart: council.dateStart
			}
		});
		if (response.data.createPortal && response.data.createPortal.id) {
			refetch();
		} else {
			setError('Ha fallado la operación');
		}
	};

	if (isLoading) {
		return (
			<LoadingSection />
		);
	}


	if (!council?.id) {
		return (
			<LoggedLayoutRoot>
				<div style={{ height: '100%', overflow: 'hidden' }}>
					<div style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						height: 'calc(100% - 3em)'
					}}>
						<div style={{ textAlign: 'center' }}>
							<div style={{ marginBottom: '1.5em' }}>
								<i style={{ color: '#9c0f0f', fontWeight: 'bold', fontSize: '70px' }} className='fas fa-exclamation-circle'></i>
							</div>
							<div style={{ color: 'black', fontWeight: 'bold', fontSize: '22px' }}>
								La id de la reunión no existe
							</div>
						</div>
					</div>
					<div style={{ textAlign: 'right' }}>
						<BasicButton
							text="Volver"
							onClick={() => window.location.replace(window.location.origin)}
							backgroundColor={{
								color: 'white',
								backgroundColor: secondary,
							}}
						/>
					</div>
				</div>
			</LoggedLayoutRoot>
		);
	}

	return (
		<LoggedLayoutRoot
			title={'Nuevo nombre para el portal'}
		>
			<div style={{ height: 'calc( 100% - 7.5em )', overflow: 'hidden' }}>
				<div
					style={{
						marginLeft: '2em',
					}}
				>
					<h2 style={{
						color: 'rgb(125, 33, 128)',
						fontSize: '18px',
						fontWeight: '700',
						marginBottom: '0.6em'
					}}>
						{translate.name}
					</h2>
					<div style={{ maxWidth: '500px' }}>
						<TextInput
							value={name}
							onChange={event => setName(event.target.value.trim().replace(/[^a-z0-9]/gi, '').toLowerCase())}
							errorText={error}
							onKeyUp={event => {
								if (event.keyCode === 13) {
									createPortal();
								}
							}}
						/>
					</div>
				</div>
			</div>
			<div style={{
				paddingTop: '.5em',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end'
			}}>
				<BasicButton
					text="Crear portal"
					onClick={createPortal}
					backgroundColor={{
						color: 'white',
						backgroundColor: secondary,
					}}
				/>
			</div>
		</LoggedLayoutRoot>
	);
};

export default CreatePortalForm;
